import { useEffect } from "react";
import { useFirebaseAuth } from "@/hooks/use-firebase-auth";
import { useSubscription } from "@/hooks/use-subscription";
import { syncSentrySubscriptionFromApp } from "@/lib/sentry";

/**
 * Single place to push subscription state (subscriptions/{uid}) into Sentry tags/context.
 * Mount once under FirebaseAuthProvider so events are not missing tier/status and anonymous users
 * are not mis-tagged as `free` (useSubscription defaults to free when no Firestore doc).
 */
export function SentryContextSync() {
  const { user } = useFirebaseAuth();
  const {
    subscriptionTier,
    subscriptionStatus,
    subscriptionSource,
    loading,
    hasPaidAccess,
    isSubscriptionConsistent,
  } = useSubscription();

  useEffect(() => {
    syncSentrySubscriptionFromApp({
      userId: user?.id ?? null,
      tier: subscriptionTier,
      status: subscriptionStatus,
      source: subscriptionSource,
      loading,
      hasPaidAccess,
      isSubscriptionConsistent,
    });
  }, [
    user?.id,
    subscriptionTier,
    subscriptionStatus,
    subscriptionSource,
    loading,
    hasPaidAccess,
    isSubscriptionConsistent,
  ]);

  return null;
}
